import { render, staticRenderFns } from "./moduleFive.vue?vue&type=template&id=108bf285"
import script from "./moduleFive.vue?vue&type=script&lang=js"
export * from "./moduleFive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports